module.exports = __webpack_public_path__ + "static/img/1494_phase_function_Paper_Points.059dbe8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1494_phase_function_Paper_Points.png
// module id = p9wY
// module chunks = 0